<template>
  <div>
    <v-dialog
      @keydown.esc="isOpen=false"
      persistent
      v-model="isOpen"
      width="416">
      <v-card>
        <div class="d-flex justify-end">
          <v-btn
            fab
            color="transparent"
            small
            depressed
            @click="closeDialog()"
            class="mr-1 mt-1"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="pt-0 px-8 title pb-4">
          {{ this.form._id ? $t('expenses.incomeCategories.editCategoryDialog.editTitle') : $t('expenses.incomeCategories.editCategoryDialog.createTitle') }}
        </v-card-title>
        <v-card-text class="px-8 pb-8">
          <v-form v-model="isValid" ref="form">
            <v-row>
              <v-col class="py-0" cols="12">
                <div class="d-flex">
                  <v-select
                    rounded
                    outlined
                    dense
                    v-model="form.type"
                    :rules="rules.required"
                    item-text="name"
                    item-value="_id"
                    :items="types"
                    :label="$t('expenses.incomeCategories.editCategoryDialog.type')"
                    @change="filterConcepts()"
                  />
                  <div class="pl-3">
                    <v-tooltip top v-if="expensesPermissions['create-income-type']">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          fab
                          color="primary"
                          x-small
                          depressed
                          @click="openAddOutgoingTypeDialog()"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Agregar tipo de egreso</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-col>
              <v-col class="py-0" cols="12">
                <div class="d-flex">
                  <v-select
                    rounded
                    outlined
                    dense
                    v-model="form.concept"
                    :rules="rules.required"
                    item-text="name"
                    item-value="_id"
                    :items="filteredConcepts.length ? filteredConcepts : concepts"
                    :label="$t('expenses.incomeCategories.editCategoryDialog.concept')"
                    @change="selectType()"
                  />
                  <div class="pl-3">
                    <v-tooltip top v-if="expensesPermissions['create-income-concept']">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          fab
                          color="primary"
                          x-small
                          depressed
                          @click="openAddOutgoingConceptDialog()"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Agregar concepto de income</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-col>
              <v-col class="py-0" cols="12">
                <EditOutlinedInput
                  v-model="form.name"
                  :rules="rules.required"
                  :label="$t('expenses.incomeCategories.editCategoryDialog.name')"
                />
              </v-col>
              <!-- <v-col class="py-0" cols="12">
                <v-checkbox
                  v-model="form.includedInCharges"
                  :label="$t('expenses.incomeCategories.editCategoryDialog.includedInCharges')"
                />
              </v-col> -->
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between px-10 pb-8">
          <Button size="x-small" type="outlined" @click="closeDialog()">
            {{ $t('expenses.incomeCategories.editCategoryDialog.buttonCancel') }}
          </Button>
          <Button size="x-small" @click="create()">
            {{ this.form._id ? $t('expenses.incomeCategories.editCategoryDialog.buttonEdit') : $t('expenses.incomeCategories.editCategoryDialog.buttonCreate') }}
          </Button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AddIncomeType
      ref="addType"
      @updated="loadTypes"
    />

    <AddIncomeConcept
      ref="addConcept"
      @updated="loadConceptsAndTypes"
    />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import AddIncomeType from '@/components/modals/AddIncomeType'
import AddIncomeConcept from '@/components/modals/AddIncomeConcept'
import Button from '@/components/elements/Button'
import EditOutlinedInput from '@/components/elements/EditOutlinedInput'

export default {
  components: {
    AddIncomeType,
    AddIncomeConcept,
    EditOutlinedInput,
    Button
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      isValid: false,
      form: {
        type: null,
        concept: null,
        name: null
        // includedInCharges: true
      },
      concepts: [],
      filteredConcepts: [],
      types: [],
      filteredType: [],
      rules: {
        required: [v => !!v || `Este campo ${this.$i18n.t('messages.isRequired')}`]
      }
    }
  },
  computed: {
    expensesPermissions () {
      return this.$store.state.login.permissions['expenses'].components['income-category'].actions
    }
  },
  watch: {
    isOpen: async function (val) {
      if (val) {
        await this.loadTypes()
        await this.loadConcepts()
      }
    }
  },
  methods: {
    openDialog (category) {
      if (category) {
        this.form = {
          ...category
        }
      }
      this.isOpen = true
    },
    resetForm () {
      this.form = {
        type: null,
        concept: null,
        name: null
        // includedInCharges: true
      }
      this.$refs.form.resetValidation()
    },
    closeDialog () {
      this.isOpen = false
      this.resetForm()
      this.filteredConcepts = []
    },
    async create () {
      this.$refs.form.validate()
      if (this.isValid) {
        this.overlay = true
        try {
          const payload = {
            ...this.form,
            type: 'income',
            restaurant: this.$store.state.currentRestaurant.data._id
          }
          if (this.form._id) {
            await this.$api.put(`/v1/cashflows/${this.form._id}`, payload)
          } else {
            await this.$api.post(`/v1/cashflows`, payload)
          }
          this.$emit('updated')
          this.closeDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    async loadConcepts (params = null) {
      params = params || {
        kind: 'income',
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/cashflows/concepts`, params)
        this.concepts = response.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async loadTypes (params = null) {
      params = params || {
        kind: 'income',
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/cashflows/types`, params)
        this.types = response.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async loadConceptsAndTypes () {
      await this.loadTypes()
      await this.loadConcepts()
      if (this.form.type) {
        const lastConcept = this.form.concept
        this.filterConcepts()
        if (lastConcept) {
          this.form.concept = lastConcept
        }
      }
    },
    openAddOutgoingTypeDialog () {
      this.$refs.addType.openDialog()
    },
    openAddOutgoingConceptDialog () {
      this.$refs.addConcept.openDialog()
    },
    filterConcepts () {
      this.form.concept = null
      this.filteredConcepts = this.concepts.filter(concept => concept.type === this.form.type)
    },
    selectType () {
      const selectedConcept = this.concepts.find(concept => concept._id === this.form.concept)
      this.form.type = selectedConcept.type ? this.types.find(type => type._id === selectedConcept.type) : ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .title {
    font-weight: 500;
    font-size: 22px;
    color: #01D28E;
  }
</style>
